@if (open) {
  <div class="fixed inset-0 z-[10000] flex items-end sm:items-center justify-center p-0 sm:p-4" role="dialog" aria-modal="true" [attr.aria-labelledby]="ariaLabelledBy || null">
    <div class="absolute inset-0 bg-dark-text/60 backdrop-blur-sm" (click)="onDismiss()"></div>
    <div cntFocusTrap (escape)="onDismiss()" class="cnt-bottom-sheet-panel relative bg-white rounded-t-3xl sm:rounded-2xl shadow-[0_24px_48px_rgba(0,0,0,0.2)] max-w-lg w-full max-h-[92dvh] sm:max-h-[88dvh] overflow-y-auto">
      <!-- Mobile pull handle -->
      <div class="sm:hidden pt-2 pb-1 flex justify-center" aria-hidden="true">
        <span class="block w-10 h-1 rounded-full bg-dark-text/15"></span>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
}
